import { useContext, useRef } from 'react'
import { useDispatch } from 'react-redux';
import { useOutsideClickHandler } from '../../../../Hooks/useOutsideClick';
import { closeModal, fetchInventoryProducts, setSelectedProduct } from '../../../../Features/inventoryManagementSlice';
import showhide from "../../../../Assets/ShowHide.svg";
import { updateProduct } from '../../../../lib/utils/apiCalls';
import { toast } from 'react-toastify';
import { InventoryManagementContext } from '../../../../Context/InventoryManagementContext';

function HideConfirmation() {
    const dispatch = useDispatch();
    const wrapperRef = useRef(null);

    useOutsideClickHandler(wrapperRef, () => {
        dispatch(closeModal());
        dispatch(setSelectedProduct({}));
    });

    const handleCancelClick = () => {
        dispatch(closeModal());
        dispatch(setSelectedProduct({}));
    }

    const { selectedProducts, setSelectedProducts } = useContext(InventoryManagementContext);

    const handleHideClick = async () => {
        if (selectedProducts.length > 0) {
            const hidePromises = selectedProducts.map(productId => updateProduct({
                isVisible: false
            }, productId));

            const hideAllPromise = Promise.all(hidePromises);

            toast.promise(
                hideAllPromise,
                {
                    pending: {
                        render() {
                            return 'Hiding selected products...';
                        },
                        className: 'toast-pending',
                    },
                    success: {
                        render() {
                            return 'Products hidden successfully.';
                        },
                    },
                }
            );

            try {
                await hideAllPromise;
                dispatch(fetchInventoryProducts());
                dispatch(closeModal());
                setSelectedProducts([]);
            }
            catch (err) {
                console.error('Error deleting products:', err);
            }
        }
    }

    let productVisible = true;

    return (
        <div ref={wrapperRef} className="w-[38%] h-fit bg-[#FFFFFF] rounded-xl p-6 flex flex-col gap-6 shadow-[0px_0px_12px_0px_#0000003D]">
            <div className="flex items-center gap-[10px]">
                <div className="flex flex-col gap-3 w-[calc(100%-44px)]">
                    <h1 className='font-semibold text-[18px] leading-6 text-[#121212]'>Are you sure want to hide?</h1>

                    <p className='font-normal text-[14px] leading-5 text-[#666666]'>Enabling this option will mark products as inactive, hiding them from both the collection and the store. You can reactivate the product at any time.</p>
                </div>

                <button className={`outline-none flex items-center w-11 h-6 p-[2px] rounded-xl ${productVisible ? 'bg-[#4F46E5]' : 'bg-[#E5E7EB]'}`}>
                    <img className={`${productVisible ? 'ml-auto mr-[-2px]' : 'ml-[-2px]'} rounded-full`} src={showhide} alt="" />
                </button>
            </div>

            <div className="flex justify-end gap-3 font-medium font-inter">
                <button onClick={handleCancelClick} className='text-[14px] leading-5 text-[#374151] rounded-md px-[17px] py-[9px] bg-[#FFFFFF] border border-[#D1D5DB] shadow-[0px_1px_2px_0px_#0000000D]'>Cancel</button>

                <button onClick={handleHideClick} className='text-[14px] leading-5 text-[#FFFFFF] rounded-md px-[17px] py-[9px] bg-primaryColor shadow-[0px_1px_2px_0px_#0000000D]'>Save changes</button>
            </div>
        </div>
    );
}

export default HideConfirmation;
